import { render, staticRenderFns } from "./course_home.vue?vue&type=template&id=25a98d34&scoped=true"
import script from "./course_home.vue?vue&type=script&lang=js"
export * from "./course_home.vue?vue&type=script&lang=js"
import style0 from "./course_home.vue?vue&type=style&index=0&id=25a98d34&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25a98d34",
  null
  
)

export default component.exports